import { NavBar } from '@design-system/NavBar';
import { Button } from '@design-system/Button';
import { LocalStorage } from '@/utils/LocalStorage';
import { SettingsPageSupportSection } from './SettingsPageSupportSection';
import { SettingsPageAccountSection } from './SettingsPageAccountSection';
import { SettingsPagePreferencesSection } from './SettingsPagePreferencesSection';
import { SettingsPageHealthProfileSection } from './SettingsPageHealthProfileSection';
// import { SettingsPageHealthNotificationsSection } from './SettingsPageHealthNotificationsSection';
import { SettingsPagePoliciesSection } from './SettingsPagePoliciesSection';
import { useUserStore } from '@hooks/useUserStore';
import { useLogoutQuery } from '@viome/viome-base/src/usecase/Login/LoginQuery';
import { LoadingPage } from '@screens/LoadingPage';
import { toast } from '@hooks/use-toast';
import { useQueryClient } from '@tanstack/react-query';
import { Sentry } from '@/main';

export const SettingsPage = () => {
  const { setUser } = useUserStore();
  const queryClient = useQueryClient();
  const { refetch: logout, isLoading } = useLogoutQuery({ enabled: false });

  if (isLoading) {
    return <LoadingPage />;
  }

  const clearAllCachesAndState = () => {
    queryClient.clear();
    setUser(undefined);
    Sentry.setUser(null);
    LocalStorage.clear();
    LocalStorage.removeItem('user');
    LocalStorage.removeItem('bootup');
    LocalStorage.removeItem('auth_token');
    sessionStorage.clear();
  };

  const handleLogout = async () => {
    try {
      const response = await logout();

      if (response?.isError) {
        toast({
          variant: 'destructive',
          description: `Failed to logout, please try again`,
        });
      }
      clearAllCachesAndState();
    } catch (error) {
      toast({
        variant: 'destructive',
        description: `Failed to logout, please try again ${error}`,
      });
    }
  };

  return (
    <section className="page-container page-container flex flex-col gap-12">
      <div className="flex flex-col gap-6 md:gap-12">
        <NavBar buttonLabel={<span className="max-md:hidden">Account</span>} />

        <h1 className="typography-d2 text-primary font-normal">
          Settings & Information
        </h1>
      </div>

      <SettingsPageAccountSection />
      <SettingsPagePreferencesSection />
      <SettingsPageHealthProfileSection />
      {/* <SettingsPageHealthNotificationsSection /> */}
      <SettingsPageSupportSection />
      <SettingsPagePoliciesSection />

      <Button variant="secondary" className="text-error" onClick={handleLogout}>
        Log out
      </Button>
    </section>
  );
};
